import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {getReturnPath} from '../selectors';
import {Page} from '../../layout/components';
import {SetPasswordForm} from '../../passwordManagement/components';
import toastr from 'toastr';
import {withRouter} from 'react-router';

import {
  activateAccount,
} from '../actions';

import {
  resetSetPasswordForm,
  setParamData,
  setSetPasswordFormFields,
} from '../../passwordManagement/actions';

import {
  setPasswordModelSelector,
  submittingSelector,
} from '../../passwordManagement/selectors/pages/list';

import React, {Component, PropTypes} from 'react';

class ActivateAccountPage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentWillMount() {
    this.props.resetSetPasswordForm();
  }

  componentDidMount() {
    const {userId, token} = this.props.params;

    this.props.setParamData({userId, token});
  }

  handleFieldChange(event) {
    const {name, value} = event.target;
    this.props.handleFieldChange(name, value);
  }

  handleSubmitAction(event) {
    event.preventDefault();

    const {handleSubmit, model, router, params} = this.props;

    handleSubmit(model)
      .then(() => {
        toastr.success('Your password has been set.', 'Account Activated!');
        router.push('/');
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          toastr.error(error.response.data, 'Error');
          return;
        }
        toastr.error('An error occurred while attempting to activate your account.', 'Error');
      });
  }

  render() {
    const {model, submitting} = this.props;

    return (
      <Page pageClassName="set-password-page">
        <SetPasswordForm
          title="Activate Account"
          enterLabel="Enter Password"
          confirmLabel="Confirm Password"
          message="Create a password for your new account"
          model={model}
          submitting={submitting}
          onFieldChange={this.handleFieldChange}
          onSubmit={this.handleSubmitAction} />
      </Page>
    );
  }
}

ActivateAccountPage.propTypes = {
  handleFieldChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  model: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  resetSetPasswordForm: PropTypes.func.isRequired,
  returnPath: PropTypes.string,
  router: PropTypes.object.isRequired,
  setParamData: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    model: setPasswordModelSelector(state),
    returnPath: getReturnPath(state),
    submitting: submittingSelector(state),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    resetSetPasswordForm,
    setParamData,
    handleFieldChange: setSetPasswordFormFields,
    handleSubmit: activateAccount,
  }
)(ActivateAccountPage));



// WEBPACK FOOTER //
// ./app/features/authentication/containers/ActivateAccountPage.js